import React,{useState,useEffect,useContext} from 'react'
import {Container,Row,Col,Form,Button,Alert,Modal} from 'react-bootstrap'
import {IconContext} from 'react-icons'
import {HiInformationCircle} from 'react-icons/hi'
import {HiTemplate} from 'react-icons/hi'
import {AiFillSetting} from 'react-icons/ai'
import {MdError} from 'react-icons/md'
import {HiBadgeCheck} from 'react-icons/hi'
import {FaWindowClose} from 'react-icons/fa'
import axios from 'axios'
import Loading from '../../components/Loading/index.js'
import LoadingFailed from '../../components/LoadingFailed/index.js'
import EmptyList from '../../components/EmptyList/index.js'
import { v4 as uuidv4 } from 'uuid';
import PrefixContext from "../../context/PrefixContext.js";
import AuthContext from "../../context/AuthContext.js";

import Template1 from '../../resumes/t1/index.js'
import Template2 from '../../resumes/t2/index.js'

function Index() {
    
    const PrefixContextData = useContext(PrefixContext);
    const AuthContextData = useContext(AuthContext);
    
    const [infoModal, setinfoModal] = useState(false)
    const handleClose = () => setinfoModal(false);
    const handleShow = () => setinfoModal(true);
    
    const [templates, settemplates] = useState()
    const [resumes,setresumes] = useState()
    const [resumeLoading,setresumeLoading] = useState('LOADING')
    const [data, setdata] = useState({
        'datasetConfig':null,'dataset':null,'template':null,selectedTemplate:null
    })
    const [loading, setloading] = useState('LOADING')
    const [resumeAddstatus, setresumeAddstatus] = useState('')

    const getTemplates = () => {
        axios.get(PrefixContextData.prefixUrl+'data/templates')
            .then(response => {
                if(response.status === 200){
                    setloading('LOADED');
                    settemplates(response.data);
                }
                else{
                    setloading('FAILED');
                }
            })
            .catch(error => {
                setloading('FAILED');
            });
    }

    
    const getResumeList = async () => {
        let token = localStorage.getItem('auth-token');
        axios.defaults.headers.common['Authorization'] = token;
        axios.get(PrefixContextData.prefixUrl+'data/resumes')
            .then(response => {
                if(response.status === 200){
                    setresumeLoading('LOADED');
                    setresumes(response.data);
                }
                else{
                    setresumeLoading('FAILED');
                }
            })
            .catch(error => {
                if(error.response!==undefined){
                    if(error.response.status === 401){
                        AuthContextData.logout()
                    }
                }
                setresumeLoading('FAILED');
            });
    }


    useEffect(() => {
        getTemplates();
        getResumeList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const addResumeHandler = (e) =>{
        e.preventDefault();
        window.scrollTo(0, 0)
        if (resumeLoading === 'WAITING') return;
        setresumeAddstatus('WAITING')
        let token = localStorage.getItem('auth-token');
        axios.defaults.headers.common['Authorization'] = token;
        axios.post(PrefixContextData.prefixUrl+'data/resume/add',data)
            .then(response => {
                if(response.status === 200){
                    setresumeAddstatus('ADDED')
                }
                else{
                    setresumeAddstatus('FAILED')
                }
            })
            .catch(error => {
                setresumeAddstatus('FAILED')
                if(error.response!==undefined){
                    if(error.response.status === 401){
                        AuthContextData.logout()
                    }
                }
            });
    }

    const handleChange = (e) => {
        const newData = {...data}
        newData[e.target.name] = e.target.value;
        if(newData.datasetConfig === 'new'){
           newData.dataset = 'null'
           newData.selectedTemplate = 'null'
        }
        if(e.target.name === 'dataset'){
            newData.selectedTemplate = e.target.id
        }
        setdata(newData);
    }

        
    function ResumeList(props){
        return (
            <>
                <p>Please select a resume which you want to use for linking / copying </p>
                {
                    (props.resumes !== undefined && Array.isArray(props.resumes) && props.resumes.length !== 0) &&
                    <div className="d-flex" style={{overflow:'auto'}}>
                        {props.resumes.map((el)=>{
                            if(el.template_id.identity === "TemplateOne"){
                                return <div  key={uuidv4()}  style={{margin:'20px 40px'}}>
                                    <div className="bg-white mb-2" style={{width:'345px',height:'375px',contain:'strict'}}>
                                        <Template1 {...el} size="small"/>
                                    </div>
                                    <Form.Check
                                        type="radio"
                                        name="dataset"
                                        id={el._id}
                                        onChange={handleChange}
                                        checked= {(data.selectedTemplate === el._id) ? true : false}
                                        label={el.template_id.name}
                                        value={el.dataset_id._id}
                                        required
                                    />
                                </div>
                            }
                            else if(el.template_id.identity === "TemplateTwo"){
                                return <div key={uuidv4()} style={{margin:'20px'}}>
                                    <div className="bg-white mb-2" style={{width:'345px',height:'375px',contain:'strict'}}>
                                        <Template2 {...el} size="small"/>
                                    </div>
                                    <Form.Check
                                        type="radio"
                                        name="dataset"
                                        id={el._id}
                                        onChange={handleChange}
                                        checked= {(data.selectedTemplate === el._id) ? true : false}
                                        label={el.template_id.name}
                                        value={el.dataset_id._id}
                                        required
                                    />
                                </div>
                            }
                            else{
                                return null;
                            }
                        })}
                    </div>
                }
            </>
        )
    }

    return (
        <>
        <section className="page-heading-margin bg-secondary">
            <Container>
                <Row>
                    <Col md="12">
                        <form onSubmit={(e)=>addResumeHandler(e)}>
                            {resumeAddstatus === 'FAILED' && <div className="text-center">
                                <Alert className="d-inline-block" variant="danger"><MdError/>&nbsp;&nbsp;Resume Addition Failed</Alert>
                            </div>}
                            {resumeAddstatus === 'ADDED' && <div className="text-center">
                                <Alert className="d-inline-block" variant="success"><HiBadgeCheck/>&nbsp;&nbsp;Resume Added Successfully</Alert>
                            </div>}
                            {resumeAddstatus === 'WAITING' && <div className="text-center">
                                <Alert className="d-inline-block" variant="warning"><HiBadgeCheck/>&nbsp;&nbsp;Please Wait Adding Resume ...</Alert>
                            </div>}
                            <h5 className="mt-3 mt-md-4">
                                <IconContext.Provider value={{ color: "white", className: "global-class-name" }}>
                                    <div className="bg-primary d-inline-block p-2 mx-2 rounded">
                                        <AiFillSetting />
                                    </div>
                                </IconContext.Provider>
                                &nbsp;&nbsp;Select template data configuration <span className="text-danger">*</span>
                            </h5>
                            <Row>
                                <Col md="4" lg="2">
                                    <p className="mx-4 text-left mt-2">Select Anyone : </p>
                                </Col>
                                <Col md="8" lg="10">
                                    <div className="d-flex align-items-baseline">
                                        <Form.Check
                                            type="radio"
                                            name="datasetConfig"
                                            label="Create a New Dataset"
                                            value="new"
                                            checked= {(data.datasetConfig === 'new') ? true : false}
                                            onChange={handleChange}
                                            required
                                            />
                                        <Button variant="" onClick={handleShow}><HiInformationCircle/></Button>
                                    </div>
                                    {
                                        ( resumes !== undefined && resumes.length !==0 ) && <>
                                        <div className="d-flex align-items-baseline">
                                            <Form.Check
                                                type="radio"
                                                name="datasetConfig"
                                                label="Link to an exisiting Dataset"
                                                value="link"
                                                checked= {(data.datasetConfig === 'link') ? true : false}
                                                onChange={handleChange}
                                                required
                                                />
                                            <Button variant="" onClick={handleShow}><HiInformationCircle/></Button>
                                        </div>
                                        <div className="d-flex align-items-baseline">
                                            <Form.Check
                                                type="radio"
                                                name="datasetConfig"
                                                label="Copy Data from Existing Dataset"
                                                value="copy"
                                                checked= {(data.datasetConfig === 'copy') ? true : false}
                                                onChange={handleChange}
                                                required
                                                />
                                            <Button variant="" onClick={handleShow}><HiInformationCircle/></Button>
                                        </div> </>
                                    }
                                </Col>
                            </Row>


                            {(resumeLoading === 'LOADING' && (data.datasetConfig === 'link' || data.datasetConfig === 'copy')) &&
                            <div className="mt-2 py-3 py-md-5 bg-white">
                                <Loading size="small"/>
                            </div>
                            }
                            {(resumeLoading === 'LOADED' && (data.datasetConfig === 'link' || data.datasetConfig === 'copy')) &&
                                <ResumeList resumes={resumes}
                            />}


                            {loading === 'LOADING' && <Loading type="withImage"/>}
                            {loading === 'FAILED' && <LoadingFailed/>}
                            {
                                <>
                                    <h5 className="mt-3 mt-md-3">
                                    <IconContext.Provider value={{ color: "white", className: "global-class-name" }}>
                                        <div className="bg-primary d-inline-block p-2 mx-2 rounded">
                                            <HiTemplate />
                                        </div>
                                    </IconContext.Provider>
                                    &nbsp;&nbsp;Select a template <span className="text-danger">*</span>
                                    </h5>
                                        {(loading === 'LOADED' && templates !== undefined && templates.length !== 0) ? <>
                                            <div className="d-flex flex-wrap pt-3 pt-md-3">
                                            {templates.map((el)=>{
                                                return <div key={uuidv4()} className="d-flex flex-column mx-auto m-md-0 pb-5">
                                                        <img style={{width:"250px",marginRight:"50px",paddingBottom:"10px"}} src={el.image} alt=""/>
                                                        <Form.Check
                                                            type="radio"
                                                            name="template"
                                                            value={el._id}
                                                            checked = {data.template === el._id ? true :false}
                                                            label={el.name}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>
                                            })}
                                        </div>
                                        <div className="text-center mt-2 mt-md-0">
                                            <Button className="ml-auto mr-0" type="submit">Submit</Button>
                                        </div>
                                    </> : <EmptyList />}
                                </>
                            }
        
                            
                        </form>

                    </Col>
                </Row>
            </Container>
        </section>

        <Modal show={infoModal} onHide={handleClose}>
            <div className="px-4 cursor-pointer" style={{position:'absolute',top:'32px',right:'25px',zIndex:'4'}} onClick={handleClose}>
                <IconContext.Provider value={{color:'#6c757d'}}>
                    <FaWindowClose/>
                </IconContext.Provider>
            </div>
            <Modal.Body className="px-4">
            <h5 className="py-3">Dataset Configuration</h5>
            <p><b>Create New Dataset</b> : Select this option if you want to create a new set of data.</p>
            <p><b>Link to an exisiting Dataset</b> : Select this option if you want to use an exisiting dataset for the new resume.<br/> Note :- Change in this resume will lead to change in all linked resumes.</p>
            <p><b>Copy Data from Existing Dataset</b> : Select this option if you want to copy data from exisiting dataset to a new one.<br/> Note :- Change in this resume will <b>NOT</b> lead to change in all linked resumes.</p>
            </Modal.Body>
        </Modal>  
        </>
    )
}

export default Index
